const linkedinNewsletter = [
	{
		path: '/jobs/linkedin-newsletter/list',
		name: 'jobs-linkedin-newsletter-list',
		component: () =>
			import(
				/* webpackChunkName: "LinkedInNewsletterList" */ '@/views/jobs/linkedin-newsletter/list.vue'
			),
		meta: {
			layout: 'content',
			module: 'MGJ,linkedin-newsletter',
		},
	},
	{
		path: '/jobs/linkedin-newsletter/edit/:id',
		name: 'jobs-linkedin-newsletter-edit',
		component: () =>
			import(
				/* webpackChunkName: "LinkedInNewsletterEdit" */ '@/views/jobs/linkedin-newsletter/edit.vue'
			),
		meta: {
			layout: 'content',
			module: 'MGJ,linkedin-newsletter',
		},
	},
	{
		path: '/jobs/linkedin-newsletter/config',
		name: 'jobs-linkedin-newsletter-config',
		component: () =>
			import(
				/* webpackChunkName: "LinkedInNewsletterConfig" */ '@/views/jobs/linkedin-newsletter/config.vue'
			),
		meta: {
			layout: 'content',
			module: 'MGJ,linkedin-newsletter',
		},
	},
]

export default linkedinNewsletter
